import { useQuery } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

import { TClip } from '../types';

export const getClipById = ({ id }): Promise<TClip> => {
  return mediaManagerClient.get(`/api/v1/clips/${id}`);
};
type QueryFnType = typeof getClipById;

type UseLogosByIdOptions = {
  config?: QueryConfig<QueryFnType>;
  id: string;
};

export const useGetClipById = ({ config, id }: UseLogosByIdOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    enabled: !!id,
    queryKey: [`clips-${id}`],
    queryFn: () => getClipById({ id }),
  });
};
